/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';
	const $path = location.pathname;
	let basePath = $path.split('/')[1];
	let _newsPagePath = `/${basePath === 'en' || basePath === 'cn' ? basePath : 'jp'}/news/`;
	let param = new URLSearchParams(window.location.search);
	let selectedCat = $path.includes('/ir/') ? 'ir' : param.get('p_n_category');
	const blankIcon = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#blank" /></svg>';
	const pdfIcon = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#pdf" /></svg>';

	const newsOutput = document.querySelector('.js-news-output');
	const msgList = {
		en: 'No relevant news available.',
		cn: '没有相关新闻。',
		default: '該当するニュースがありません。'
	};
	noItemsMsg = msgList[basePath] || msgList.default;

	// JSON取得 ===============================================
	const cmsNewsJson = () => {
		let returnUrl = `/${basePath}/ajax/news/list/all/list.json`;
		if (selectedCat !== null) {
			returnUrl += '?p_n_category='+ selectedCat;
		}
		return returnUrl;
	}
	const cmsTopNewsJson = `/${basePath}/ajax/top/news/list/all/list.json`;
	// 宝印刷 IRニュースJSON
	let irNewsJson = 'https://www.xj-storage.jp/public-list/GetList.aspx?company=69230&dataId=47101f1a-fcd6-42ba-9ecd-929b746973f7&callback=irnewscallback';
	if(basePath === 'en') {
		irNewsJson = 'https://www.xj-storage.jp/public-list/GetList2.aspx?company=69230&dataId=a2bf6480-3f58-4bbb-8596-2a2f12778d7e&callback=irnewscallback';
	}
	// ニュースIDからカテゴリ取得する用
	const nresCategoryJson = (_id) => {
		return `/${basePath}/ajaxnews/detail/category_name/${_id}.json`;
	}

	// <共通> ===============================================
	// CMSoDデータ用（byte、「,」無し）
	const bytesToSize = (bytes) => {
		const sizes = ['Bytes', 'KB', 'MB', 'GB'];
		if (bytes === 0) return '0 Byte';
		let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
		let convSize = Math.floor(bytes / Math.pow(1024, i)* Math.pow(10, 1)) / Math.pow(10, 1);
		// KBのとき、小数点切り捨て
		if (i === 1) convSize = Math.floor(convSize);
		return convSize + sizes[i];
	};
	// 日付をフォーマット化 (宝印刷)
	const formatDateWizlabo = (_date) => {
		let thisDate = new Date(_date);
		let year = thisDate.getFullYear();
		let month = ('0' + (thisDate.getMonth() + 1)).slice(-2); // 月は0始まりのため+1
		let day = ('0' + thisDate.getDate()).slice(-2);
		let formattedDate = `${year}年${month}月${day}日`;
		let sortDate = `${year}-${month}-${day}`;
		return {datetime : sortDate, text: formattedDate}
	}
	const formatEnDateWizlabo = (_date) => {
		const date = new Date(_date.replace(/-/g, '/'));  // YYYY/MM/DD をパース可能な形式に修正
		const formatter = new Intl.DateTimeFormat('en-US', {
			month: 'short',
			day: 'numeric',
			year: 'numeric'
		});
		return formatter.format(date);
	}



	// <ニュース一覧> 年号プルダウン
	const dropDown = (_latestY, _earliestY) => {
		const yearList = document.querySelector('.js-news-yearList');
		if(yearList) {
			// 最新と最古の年を取得
			let cmsLatestY = document.querySelector('.js-news-latest-year').textContent;
			let cmsEarliestY = document.querySelector('.js-news-earliest-year').textContent;
			let latestY = Math.max(_latestY, cmsLatestY);
			let earliestY = Math.min(_earliestY, cmsEarliestY);

			// ドロップダウンリスト要素を取得
			const yearListUl = yearList.querySelector('ul');
			const selectedSpan = yearList.querySelector('.__selected')
			let latesText = '最新（6ヵ月）';
			if(basePath === 'en') {
				latesText = 'Latest 6 months';
			}
			if(basePath === 'cn') {
				latesText = '最新（6个月）';
			}
			// 最新から最古の年までのオプションを生成し追加
			let isIncludedInpath = '';
			yearListUl.innerHTML += '<li class="mod-select02-list-option" data-name="" role="option" aria-selected="false">'+ latesText +'</li>';
			for(var i =latestY; i>=earliestY; i--) {
				const option = document.createElement('li');
				option.classList.add('mod-select02-list-option');
				option.setAttribute('data-name', i.toString());
				option.setAttribute('role', 'option');
				option.setAttribute('tabindex', 0);
				option.setAttribute('aria-selected', false);

				option.textContent = $path.includes('/en/') ? i.toString() : i.toString() + '年';
				yearListUl.appendChild(option);
				if($path.includes(i)) {
					isIncludedInpath = `${i}`;
				}
			}
			if (isIncludedInpath != '') {
				// selectedSpan.textContent = $path.includes('/jp/') ? isIncludedInpath + '年' : isIncludedInpath();
				selectedSpan.textContent = $path.includes('/en/') ? isIncludedInpath : isIncludedInpath + '年';
				selectedSpan.setAttribute('data-name', i);
			} else {
				selectedSpan.textContent = latesText;
				selectedSpan.setAttribute('data-name', '');
			}
			yearList.classList.remove('is-disable');

			 // キーボード操作用のイベントリスナー
			 yearList.addEventListener('keydown', function (event) {
				switch (event.key) {
					case 'Enter':
					case ' ':
						event.preventDefault();
						slideDown(yearListUl);
						break;
					case 'ArrowDown':
						event.preventDefault();
						slideUp(yearListUl);
						break;
					case 'Escape':
						slideUp(yearListUl);
						break;
				}
			});
			function slideDown(element) {
				element.style.display = 'block';
				element.style.maxHeight = element.scrollHeight + 'px';
			}
			function slideUp(element) {
				element.style.maxHeight = null;
				element.style.display = 'none';
			}

			// ドロップダウンリストの変更イベントを処理(プルダウンの場合)
			yearListUl.querySelectorAll('li').forEach(element => {
				element.addEventListener('click', (e) => {
					let selectedY = e.currentTarget.getAttribute('data-name');
					param.delete('page');
					if($path.includes('/tags/')) {
						let tagCode = $path.split('/')[4]
						_newsPagePath += 'tags/'+ tagCode +'/';
					}
					let targetUrl = selectedY === '' ? _newsPagePath : _newsPagePath + selectedY + '/';
					location.href = param !== '' ? targetUrl +'?'+ param : targetUrl;
				});
			});

			// キーボード操作用のイベントリスナー
			yearList.addEventListener('keydown', function (event) {
				const selectedOption = yearList.querySelector('.mod-select02-list-option[aria-selected="true"]');
				const options = Array.from(yearListUl.querySelectorAll('li'));

				switch (event.key) {
					case 'Enter':
						let targetY = event.target.getAttribute('data-name');
						if(targetY !== '' && targetY !== null) {
							param.delete('page');
							if($path.includes('/tags/')) {
								let tagCode = $path.split('/')[4]
								_newsPagePath += 'tags/'+ tagCode +'/';
							}
							let targetUrl = targetY === '' ? _newsPagePath : _newsPagePath + targetY + '/';
							location.href = param !== '' ? targetUrl +'?'+ param : targetUrl;
						}
					case ' ':
						event.preventDefault();
						if (selectedOption) {
							slideDown(yearListUl);
							handleOptionSelect(selectedOption);
						}
						break;
					case 'ArrowDown':
						event.preventDefault();
						if (selectedOption) {
							let nextOption = options[options.indexOf(selectedOption) + 1] || options[0];  // 循環
							updateSelectedOption(nextOption);
						}
						break;
					case 'ArrowUp':
						event.preventDefault();
						if (selectedOption) {
							let prevOption = options[options.indexOf(selectedOption) - 1] || options[options.length - 1];  // 循環
							updateSelectedOption(prevOption);
						}
						break;
					case 'Escape':
						slideUp(yearListUl);
						break;
				}
			});
		}
	};
	// 中身の描画が終わるまでクリックできないようにする
	const yearList = document.querySelector('.js-news-yearList');
	if(yearList) {
		yearList.classList.add('is-disable');
	}

	// tablet/sp カテゴリプルダウン
	const spNewsCategory = () => {
		const categorySelect = document.querySelector('.js-newsCategory');
		if(categorySelect) {
			const selected = categorySelect.querySelector('.__selected');
			const options = categorySelect.querySelectorAll('.mod-select02-list-option');
			options.forEach(elem => {
				let thisCategory = elem.getAttribute('data-name');
				// 読み込み時：選択済みのカテゴリをアクティブにする
				if(thisCategory === selectedCat) {
					selected.textContent = elem.textContent;
					elem.classList.add('is-selected');
				}

				// カテゴリ変更時
				elem.addEventListener('click', (e) => {
					let thisHref = document.querySelector('.rt_category_href_'+ thisCategory).getAttribute('href');
					location.href = thisHref;
				});
			});
		}
	};

	// <ニュース一覧>
	const createNews = async () => {
		// 現在の日付を取得
		const currentDate = new Date();
		// 半年前の日付を計算
		const sixMonthsAgo = new Date();
		sixMonthsAgo.setMonth(currentDate.getMonth() - 6);

		if(newsOutput) {
			const yearList = document.querySelector('.js-news-yearList');
			// URLの中に年（4桁の数字）が含まれる場合は年を取得
			const match = $path.match(/\/(\d{4})\//);

			let allNews = [];

			let html = await fetch('/common/js/html/news-list.html').then(res => res.text());

			// カレントのカテゴリボタンをアクティブにする
			if(selectedCat !== null) {
				let categoryBtn = document.querySelectorAll('.js-news-category');
				categoryBtn.forEach(ele => {
					let thisParam = ele.getAttribute('href').split('?p_n_category=')[1];

					if(thisParam === selectedCat) {
						ele.classList.add(a);
					} else {
						ele.classList.remove(a);
					}
				})
			} else {
				document.querySelectorAll('.js-news-category')[0].classList.add(a);
			}

			fetch(cmsNewsJson())
			.then(response => response.json())
			.then((data) => {
				const newsData = data.rt_bn_news;
				if(newsData.length) {

					for(let i=0; i<newsData.length; i++) {
						if(newsData[i] !== undefined) {
							let _title = newsData[i].rt_cf_n_title.content[0];
							let _cat = newsData[i].rt_cf_n_category_name.content[0];
							let _date = newsData[i].rt_cf_n_date.content;
							let _datetime = newsData[i].cf_n_date;
							let _href = newsData[i].rt_cf_n_href;
							let _hrefLink = _href.href;
							let _target = _href.target;
							let _pdf = newsData[i].rt_cf_n_attachment_file_icon_pdf;
							let _pdfSize = newsData[i].rt_cf_n_attachment_file_size;
							let _priority = newsData[i].cf_n_priority;
							let icon = _pdf !== null ? pdfIcon : (_target === '_blank' ? blankIcon : '');
							let thisTarget = _target === undefined ? '' : _target;
							let _tags = newsData[i].cf_n_tags;
							let tagList = '';

							let pdfSize = '';
							if(_pdfSize !== null) {
								pdfSize = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize.content)}</span>)</span>`;
							}
							if(_tags !== '' && _tags !== undefined && _tags !== null) {
								_tags.forEach(ele => {
									tagList += `<li><a href="${ele.rt_cf_n_tags.href}" class="__tag">${ele.rt_cf_n_tags.content}</a></li>`;
								})
							}

							let isDisable = _hrefLink === '#' ? 'is-disable' : '';
							let catTag = '<span class="mod-label">'+ _cat +'</span>';

							let thisDatetime = new Date(_datetime);

							let thisHtml = html
								.replaceAll('{!href!}', _hrefLink)
								.replaceAll('{!target!}', thisTarget)
								.replaceAll('{!isDisable!}', isDisable)
								.replaceAll('{!date!}', _date)
								.replaceAll('{!category!}', catTag)
								.replaceAll('{!title!}', _title)
								.replaceAll('{!pdfSize!}', pdfSize)
								.replaceAll('{!icon!}', icon)
								.replaceAll('{!tags!}', tagList)

							if (match) {
								let selectedYear = match[1];
								if(thisDatetime.getFullYear() == selectedYear) {
									allNews.push({datetime : thisDatetime, html : thisHtml, priority: _priority});
								}
							} else {
								allNews.push({datetime : thisDatetime, html : thisHtml, priority: _priority});
							}
						}
					}
				}
			})
			.then(() => {
				if(basePath !== 'cn') {
					// 日本語／英語
					// 宝印刷のデータを取得
					return new Promise((resolve) => {
						window.irnewscallback = (data) => {
							const irNewsData = data.items;
							if(irNewsData.length) {
								// 宝印刷のニュースの年号を含めたプルダウンを生成
								let irLatestY = new Date((irNewsData[0].publishDate)).getFullYear();
								let irOldestY = 2016
								dropDown(irLatestY, irOldestY);

								if(selectedCat === null || selectedCat === 'ir') {
									for(let i=0; i<irNewsData.length; i++) {
										if(irNewsData[i] !== undefined) {
											let _title = irNewsData[i].title;
											let _cat = $path.includes('/en/') ? 'IR' : $path.includes('/cn/') ? '股东资讯' : '株主・投資家情報';
											let _date = irNewsData[i].publishDate;
											let _datetime = formatDateWizlabo(_date).datetime;
											let _textdate = basePath === 'en' ? formatEnDateWizlabo(_date) : formatDateWizlabo(_date).text;
											let _href = irNewsData[i].files;
											let _hrefLink = _href[0].url;
											let _pdfSize = _href[0].size;
											let extension = _hrefLink.split('.').pop();
											let icon = extension === 'pdf' ? pdfIcon : blankIcon;
											let thisTarget = '_target';
											let pdfSize = '';

											if(_pdfSize !== '0') {
												pdfSize = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize)}</span>)</span>`;
											}

											let isDisable = _hrefLink === '#' ? 'is-disable' : '';
											let catTag = '<span class="mod-label">'+ _cat +'</span>';

											let thisDatetime = new Date(_date);

											let thisHtml = html
												.replaceAll('{!href!}', _hrefLink)
												.replaceAll('{!target!}', thisTarget)
												.replaceAll('{!isDisable!}', isDisable)
												.replaceAll('{!date!}', _textdate)
												.replaceAll('{!category!}', catTag)
												.replaceAll('{!title!}', _title)
												.replaceAll('{!pdfSize!}', pdfSize)
												.replaceAll('{!icon!}', icon)
												.replaceAll('{!tags!}', '')

											if (match) {
												let selectedYear = match[1];
												if(thisDatetime.getFullYear() == selectedYear) {
													allNews.push({datetime : thisDatetime, html : thisHtml, priority: 0});
												}
											} else {
												allNews.push({datetime : thisDatetime, html : thisHtml, priority: 0});
											}
										}
									}
								}
							}
							resolve();
						}
						const script = document.createElement('script');
						script.src = irNewsJson;
						document.body.appendChild(script);
					});
				} else {
					// 中国語
					let cmsLatestY = document.querySelector('.js-news-latest-year').textContent;
					let cmsEarliestY = document.querySelector('.js-news-earliest-year').textContent;
					dropDown(cmsLatestY, cmsEarliestY);
				}
			})
			.then(() => {
				// 日時でソート
				allNews.sort(
					function(x, y){
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if(xDate > yDate) return-1;
						if(xDate < yDate) return 1;
						return 0;
					}
				);
				// 優先表示でソート
				allNews.sort(
					function(x, y){
						let xDate = x['priority'];
						let yDate = y['priority'];
						if(xDate > yDate) return-1;
						if(xDate < yDate) return 1;
						return 0;
					}
				);

				if (match) {
					// <年別>ニュースリスト＆ページャー描画
					createPagenate(allNews);
				} else {
					// <最新>最新ニュースを格納する配列
					const latestNews = [];
					// 半年以内のニュースをフィルタリング
					allNews.forEach(news => {
						const newsDate = new Date(news.datetime);
						if (newsDate >= sixMonthsAgo) {
							latestNews.push(news);
						}
					});
					// ニュースリスト＆ページャー描画
					createPagenate(latestNews);
				}
			})
			.catch(error => {
				// エラーハンドリング
				console.error('Error:', error);
			});
		}
	}
	// <ニュース一覧> ニュースとページャーを描画
	const createPagenate = (_list) => {
		// 1ぺージ20件まで表示
		const itemsPerPage = 20;

		let currentPage = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;

		// 指定されたページのニュースを取得
		const getNewsForPage = (page) => {
			const startIndex = (page - 1) * itemsPerPage;
			const endIndex = startIndex + itemsPerPage;
			return _list.slice(startIndex, endIndex);
		}

		// ページャーの表示を更新
		const updatePager = () => {
			const totalPages = Math.ceil(_list.length / itemsPerPage);
			const pager = document.querySelector('.js-paginate');
			pager.innerHTML = '';

			// 前へボタンを追加（1ページ目以外の場合のみ）
			if (currentPage > 1) {
				const prevButton = document.createElement('button');
				prevButton.innerHTML = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_left"></use></svg>';
				prevButton.onclick = () => {
					currentPage--;
					updatePageUrl();
				};
				pager.appendChild(prevButton);
			}

			// 各ページ番号ボタンを追加
			for (let i = 1; i <= totalPages; i++) {
				const pageButton = document.createElement('button');
				pageButton.textContent = i;
				pageButton.classList.add('mod-paginate-index')
				if (i === currentPage) {
					pageButton.disabled = true;
					pageButton.classList.add(a);
				} else {
					pageButton.onclick = () => {
						currentPage = i;
						updatePageUrl();
					};
				}
				pager.appendChild(pageButton);
			}

			// 次へボタンを追加（最後のページ以外の場合のみ）
			if (currentPage < totalPages) {
				const nextButton = document.createElement('button');
				nextButton.innerHTML = '<svg aria-hidden="true"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>';
				nextButton.onclick = () => {
					currentPage++;
					updatePageUrl();
				};
				pager.appendChild(nextButton);
			}
		}

		// ニュースの表示を更新
		const renderNews = () => {
			newsOutput.innerHTML = '';
			const newsForPage = getNewsForPage(currentPage);

			newsForPage.forEach(news => {
				newsOutput.insertAdjacentHTML('beforeend', news.html);
			});

			// ページャーを更新
			updatePager();
		}

		// URLのページ番号を更新し、ページを再読み込み
		const updatePageUrl = () => {
			const url = new URL(window.location);
			url.searchParams.set('page', currentPage);
			let link = url.pathname + url.search;
			location.href = link;
		}

		// 初回レンダリング
		renderNews();

		// 0件メッセージ
		if(!_list.length) {
			const p = document.createElement('p');
			p.textContent = noItemsMsg;
			newsOutput.insertAdjacentElement('afterend', p);
		}
	}

	// <総合TOP>
	const createNewsTop = async () => {
		const categoryBtn = document.querySelectorAll('.js-news-category');
		const wrap = document.querySelectorAll('.js-news-output-wrap');
		let categoryArr = [];
		let allNews = [];
		let limit = 5;

		let html = await fetch('/common/js/html/news-list.html').then(res => res.text());

		categoryBtn.forEach(ele => {
			let thisCat = ele.getAttribute('data-target');
			let thisCatTxt = ele.querySelector('span').textContent;
			categoryArr.push({code:thisCat, name:thisCatTxt});
		})

		if(wrap.length) {
			fetch(cmsTopNewsJson)
			.then(response => response.json())
			.then((data) => {
				const newsData = data.rt_bn_news;

				if(newsData.length) {
					for(let i=0; i<newsData.length; i++) {
						if(newsData[i] !== undefined) {
							let _title = newsData[i].rt_cf_n_title.content[0];
							let _cat = newsData[i].rt_cf_n_category_name.content[0];
							let _catCode = newsData[i].cf_n_category.cf_nc_code;
							let _date = newsData[i].rt_cf_n_date.content;
							let _datetime = newsData[i].rt_cf_n_date.datetime;
							let _href = newsData[i].rt_cf_n_href;
							let _hrefLink = _href.href;
							let _target = _href.target;
							let _pdf = newsData[i].rt_cf_n_attachment_file_icon_pdf;
							let _pdfSize = newsData[i].rt_cf_n_attachment_file_size;
							let _priority = newsData[i].cf_n_priority;
							let icon = _pdf !== null ? pdfIcon : (_target === '_blank' ? blankIcon : '');
							let thisTarget = _target === undefined ? '' : _target;
							let _tags = newsData[i].cf_n_tags;
							let tagList = '';

							let pdfSize = '';
							if(_pdfSize !== null) {
								pdfSize = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize.content)}</span>)</span>`;
							}
							if(_tags !== '' && _tags !== undefined && _tags !== null) {
								_tags.forEach(ele => {
									tagList += `<li><a href="${ele.rt_cf_n_tags.href}" class="__tag">${ele.rt_cf_n_tags.content}</a></li>`;
								})
							}

							let thisDatetime = new Date(_datetime);
							let isDisable = _hrefLink === '#' ? 'is-disable' : '';

							// let catCode = categoryArr.find(category => category.name === _cat);
							let catTag = $path.includes('/ir/') ? '' : '<span class="mod-label">'+ _cat +'</span>';

							let thisHtml = html
								.replaceAll('{!href!}', _hrefLink)
								.replaceAll('{!target!}', thisTarget)
								.replaceAll('{!isDisable!}', isDisable)
								.replaceAll('{!date!}', _date)
								.replaceAll('{!category!}', catTag)
								.replaceAll('{!title!}', _title)
								.replaceAll('{!pdfSize!}', pdfSize)
								.replaceAll('{!icon!}', icon)
								.replaceAll('{!tags!}', tagList)

							if(_catCode) {
								allNews.push({datetime : thisDatetime, category : _catCode,  html : thisHtml, priority: _priority});
							}


							// 株主・投資家情報TOP
							if($path.includes('/ir/')) {
								if(_cat === 'ir') {
									allNews.push({datetime : thisDatetime, category:'ir',  html : thisHtml, priority: _priority});
								}
							}
						}
					}
				}
			})
			.then(() => {
				if(basePath !== 'cn' && (selectedCat === null || selectedCat === 'ir')) {
					// 宝印刷のデータを取得
					return new Promise((resolve) => {
						window.irnewscallback = (data) => {
							const irNewsData = data.items;
							if(irNewsData.length) {
								for(let i=0; i<limit; i++) {
									if(irNewsData[i] !== undefined) {
										let _title = irNewsData[i].title;
										let _cat = $path.includes('/en/') ? 'IR' : $path.includes('/cn/') ? '股东资讯' : '株主・投資家情報';
										let _date = irNewsData[i].publishDate;
										let _datetime = formatDateWizlabo(_date).datetime;
										let _textdate = basePath === 'en' ? formatEnDateWizlabo(_date) : formatDateWizlabo(_date).text;
										let _href = irNewsData[i].files;
										let _hrefLink = _href[0].url;
										let _pdfSize = _href[0].size;
										let extension = _hrefLink.split('.').pop();
										let icon = extension === 'pdf' ? pdfIcon : blankIcon;
										let thisTarget = '_target';
										let pdfSize = '';

										if(_pdfSize !== '0') {
											pdfSize = `<span class="__file">(PDF:<span class="">${bytesToSize(_pdfSize)}</span>)</span>`;
										}

										let isDisable = _hrefLink === '#' ? 'is-disable' : '';
										let catTag = $path.includes('/ir/') ? '' : '<span class="mod-label">'+ _cat +'</span>';

										let thisDatetime = new Date(_date);

										let thisHtml = html
											.replaceAll('{!href!}', _hrefLink)
											.replaceAll('{!target!}', thisTarget)
											.replaceAll('{!isDisable!}', isDisable)
											.replaceAll('{!date!}', _textdate)
											.replaceAll('{!category!}', catTag)
											.replaceAll('{!title!}', _title)
											.replaceAll('{!pdfSize!}', pdfSize)
											.replaceAll('{!icon!}', icon)

										allNews.push({datetime : thisDatetime, category : 'ir',  html : thisHtml, priority: 0});
									}
								}
							}
							resolve();
						}
						const script = document.createElement('script');
						script.src = irNewsJson;
						document.body.appendChild(script);
					});
				}
			})
			.then(() => {
				// 日時でソート
				allNews.sort(
					function(x, y){
						let xDate = x['datetime'];
						let yDate = y['datetime'];
						if(xDate > yDate) return-1;
						if(xDate < yDate) return 1;
						return 0;
					}
				);
				// 優先表示でソート
				allNews.sort(
					function(x, y){
						let xDate = x['priority'];
						let yDate = y['priority'];
						if(xDate > yDate) return-1;
						if(xDate < yDate) return 1;
						return 0;
					}
				);

				if(wrap.length) {
					wrap.forEach(ele => {
						let thisCat = ele.getAttribute('data-target');
						let count = 0;
						let newsOutput = ele.querySelector('.js-news-output');

						if(thisCat === 'all') { // すべてタブ
							allNews.forEach((arrele,idx) => {
								count += 1;
								if(count <= limit) {
									newsOutput.innerHTML += arrele.html;
								}
							})
						} else { // カテゴリごとのタブ
							allNews.forEach((arrele,idx) => {
								if(arrele.category === thisCat) {
									count += 1;
									if(count <= limit) {
										newsOutput.innerHTML += arrele.html;
									}
								}
							})
							// 一件も無い場合は非表示
							if(!ele.querySelectorAll('.js-news-output li').length) {
								ele.innerHTML += `<p>${noItemsMsg}</p>`;
							}
						}
					})
				}
			})
			.catch(error => {
				// エラーハンドリング
				console.error('Error:', error);
			});
		}

	}


	// <ニュース詳細> ===========================================
	// 関連情報・製品スライド
	const productsSwiper = () => {
		if(document.querySelectorAll('.js-products-slide').length) {
			let splide = new Splide('.js-products-slide.splide', {
				// type: 'loop',
				perPage: 4,
				// focus: 0,
				autoplay: false,
				interval: 5000,
				speed: 1000,
				arrows: true,
				pagination: true,
				paginationKeyboard: true,
				gap: 20,
				breakpoints: {
					1025: {
						perPage: 2,
						gap: 16,
					}
				},
			}).mount();
		}
	};
	// 関連ニューススライド
	const newsSwiper = () => {
		if(document.querySelectorAll('.js-news-slide').length) {
			let splide = new Splide('.js-news-slide.splide', {
				// type: 'loop',
				perPage: 4,
				// focus: 0,
				autoplay: false,
				interval: 5000,
				speed: 1000,
				arrows: true,
				pagination: true,
				paginationKeyboard: true,
				gap: 20,
				breakpoints: {
					1025: {
						perPage: 2,
						gap: 16,
					}
				},
			}).mount();
		}
	};
	// 関連ドキュメント・動画　0件の場合エリアごと削除
	const relationHidden = () => {
		const block = document.querySelector('.js-relation-block')
		if(block) {
			let list = block.querySelector('.news-detail-relation-list li');
			let movie = block.querySelector('.mod-movie');
			if(!list && !movie) {
				block.classList.add('di_none');
			}
		}
	}
	// 関連ニュース カテゴリ表示
	const relationNewsCategory = () => {
		const block = document.querySelector('.js-news-slide');
		if(block) {
			let item = block.querySelectorAll('.js-news-slide-item');
			item.forEach(ele => {
				let thisLink = ele.querySelectorAll('a');
				if(thisLink.length) {
					let itemId = ele.querySelector('.rt_cf_n_related_news_key').textContent;
					fetch(nresCategoryJson(itemId))
					.then(response => response.json())
					.then((data) => {
						const newsData = data.rt_bn_news_info;
						let thisCategory = '';
						if(basePath === 'en') {
							thisCategory = newsData[0].cf_n_category.cf_nc_name_en;
						} else if (basePath === 'cn') {
							thisCategory = newsData[0].cf_n_category.cf_nc_name_ch;
						} else {
							thisCategory = newsData[0].cf_n_category.cf_nc_name_jp;
						}
						ele.querySelector('.mod-label').textContent = thisCategory;
					});
				} else {
					// 非公開ニュースの場合liごと削除
					ele.remove();
				}
			});

			let itemLen = block.querySelectorAll('.js-news-slide-item').length;
			if(itemLen === 0) {
				document.querySelector('.news-detail-relationNews').remove();
			}
		}
	}

	// ==========================================================================
	// <TOP/ニュース一覧>
	spNewsCategory();
	if($path === '/'+ basePath + '/' || $path === '/'+ basePath + '/ir/') {
		createNewsTop();
	} else {
		createNews();
	}
	if($path.includes('/tags/')) {
		let latestY = document.querySelector('.js-news-latest-year').textContent;
		let earliestY = document.querySelector('.js-news-earliest-year').textContent;
		dropDown(latestY, earliestY);
	}
	// <ニュース詳細>
	relationHidden();
	relationNewsCategory();
	productsSwiper();
	newsSwiper();

})(window.FUNCTIONS);
